webpackJsonp([28],{

/***/ 1100:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1101);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("b2d922d6", content, true, {});

/***/ }),

/***/ 1101:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".option-group[data-v-7433356a]{background:#fff;width:90%;max-width:400px;height:50px;position:relative;overflow:hidden;border-radius:.25em;font-size:12px;margin:.2em auto;-webkit-transform:translateZ(0);transform:translateZ(0);top:-55px}.option-container[data-v-7433356a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;width:120%;height:100%;margin:0 -10%}.option[data-v-7433356a]{overflow:hidden;-webkit-box-flex:1;-ms-flex:1;flex:1;display:block;padding:.5em;background:#fff;position:relative;margin:0;margin-right:.2em;border-radius:.25em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;cursor:pointer;opacity:.5;-webkit-transition-duration:.4s,.2s;transition-duration:.4s,.2s;-webkit-transition-property:opacity,-webkit-transform;transition-property:opacity,-webkit-transform;transition-property:transform,opacity;transition-property:transform,opacity,-webkit-transform;-webkit-transition-timing-function:cubic-bezier(.98,0,.22,.98),linear;transition-timing-function:cubic-bezier(.98,0,.22,.98),linear;will-change:transform,opacity}.option[data-v-7433356a]:last-child{margin-right:0}.option__indicator[data-v-7433356a]{display:block;-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transition:inherit;transition:inherit;will-change:transform;position:absolute;top:.5em;right:.5em;left:.5em}.option-input[data-v-7433356a]{position:absolute;top:0;z-index:-1;visibility:hidden}.option__label[data-v-7433356a]{display:block;width:100%;font-size:1.5em;font-weight:700;-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:translateX(20%) scale(.7);transform:translateX(20%) scale(.7);-webkit-transition:inherit;transition:inherit;will-change:transform}.option__label sub[data-v-7433356a]{margin-left:.25em;font-size:9px;display:inline-block;vertical-align:10px}.option__label[data-v-7433356a]:after{content:\"\";display:block;border:2px solid #4fb848;width:100%;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:scaleX(.2);transform:scaleX(.2);-webkit-transition:inherit;transition:inherit;will-change:transform}.option:last-child .option__label[data-v-7433356a]{-webkit-transform:translateX(0) scale(.7);transform:translateX(0) scale(.7)}.option:last-child .option__indicator[data-v-7433356a]{-webkit-transform:translateX(-20%);transform:translateX(-20%)}.option-input:checked~.option[data-v-7433356a]{-webkit-transform:translateX(-20%) translateX(.2em);transform:translateX(-20%) translateX(.2em)}.option-input:checked~.option .option__indicator[data-v-7433356a]{-webkit-transform:translateX(0);transform:translateX(0)}.option-input:checked~.option .option__label[data-v-7433356a]{-webkit-transform:translateX(40%) scale(.7);transform:translateX(40%) scale(.7)}.option-input:first-child:checked~.option[data-v-7433356a]{-webkit-transform:translateX(20%) translateX(-.2em);transform:translateX(20%) translateX(-.2em)}.option-input:first-child:checked~.option .option__indicator[data-v-7433356a]{-webkit-transform:translateX(-40%);transform:translateX(-40%)}.option-input:first-child:checked~.option .option__label[data-v-7433356a]{-webkit-transform:translateX(0) scale(.7);transform:translateX(0) scale(.7)}.option-input:first-child:checked ~ .option[data-v-7433356a]:nth-of-type(1),.option-input:nth-child(2):checked~.option[data-v-7433356a]:nth-of-type(2),.option-input:nth-child(3):checked~.option[data-v-7433356a]:nth-of-type(3){opacity:1}.option-input:first-child:checked ~ .option:nth-of-type(1) .option__indicator[data-v-7433356a],.option-input:nth-child(2):checked~.option:nth-of-type(2) .option__indicator[data-v-7433356a],.option-input:nth-child(3):checked~.option:nth-of-type(3) .option__indicator[data-v-7433356a]{-webkit-transform:translateX(0);transform:translateX(0)}.option-input:first-child:checked\n  ~ .option:nth-of-type(1)\n  .option__indicator[data-v-7433356a]::after,.option-input:first-child:checked ~ .option:nth-of-type(1) .option__label[data-v-7433356a],.option-input:first-child:checked\n  ~ .option:nth-of-type(1)\n  .option__label[data-v-7433356a]::after,.option-input:nth-child(2):checked~.option:nth-of-type(2) .option__indicator[data-v-7433356a]:after,.option-input:nth-child(2):checked~.option:nth-of-type(2) .option__label[data-v-7433356a],.option-input:nth-child(2):checked~.option:nth-of-type(2) .option__label[data-v-7433356a]:after,.option-input:nth-child(3):checked~.option:nth-of-type(3) .option__indicator[data-v-7433356a]:after,.option-input:nth-child(3):checked~.option:nth-of-type(3) .option__label[data-v-7433356a],.option-input:nth-child(3):checked~.option:nth-of-type(3) .option__label[data-v-7433356a]:after{-webkit-transform:scale(1);transform:scale(1)}", "", {"version":3,"sources":["/app/src/components/availability/Home.vue"],"names":[],"mappings":"AACA,+BACE,gBAAiB,AACjB,UAAW,AACX,gBAAiB,AACjB,YAAa,AACb,kBAAmB,AACnB,gBAAiB,AACjB,oBAAsB,AACtB,eAAgB,AAChB,iBAAmB,AACnB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,mCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,0BAA2B,AACvB,uBAAwB,AACpB,oBAAqB,AAC7B,WAAY,AACZ,YAAa,AACb,aAAe,CAChB,AACD,yBACE,gBAAiB,AACjB,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,cAAe,AACf,aAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,SAAY,AACZ,kBAAoB,AACpB,oBAAsB,AACtB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,eAAgB,AAChB,WAAa,AAEb,oCAAwC,AAChC,4BAAgC,AACxC,sDAAwD,AACxD,8CAAgD,AAChD,sCAAwC,AACxC,wDAA2D,AAC3D,sEAA8E,AACtE,8DAAsE,AAC9E,6BAAgC,CACjC,AACD,oCACE,cAAgB,CACjB,AACD,oCACE,cAAe,AACf,qCAAsC,AAC9B,6BAA8B,AACtC,2BAA4B,AAC5B,mBAAoB,AACpB,sBAAuB,AACvB,kBAAmB,AACnB,SAAW,AACX,WAAa,AACb,SAAY,CACb,AAmBD,+BACE,kBAAmB,AACnB,MAAO,AACP,WAAY,AACZ,iBAAmB,CACpB,AACD,gCACE,cAAe,AACf,WAAY,AACZ,gBAAiB,AACjB,gBAAkB,AAClB,qCAAsC,AAC9B,6BAA8B,AACtC,4CAA8C,AACtC,oCAAsC,AAC9C,2BAA4B,AAC5B,mBAAoB,AACpB,qBAAuB,CACxB,AACD,oCACE,kBAAoB,AAEpB,cAAe,AACf,qBAAsB,AAEtB,mBAAqB,CACtB,AACD,sCACE,WAAY,AACZ,cAAe,AACf,yBAA0B,AAC1B,WAAY,AACZ,6BAA8B,AACtB,qBAAsB,AAC9B,6BAA+B,AACvB,qBAAuB,AAC/B,2BAA4B,AAC5B,mBAAoB,AACpB,qBAAuB,CACxB,AACD,mDACE,0CAA6C,AACrC,iCAAqC,CAC9C,AACD,uDACE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,+CACE,oDAAsD,AAC9C,2CAA8C,CACvD,AACD,kEACE,gCAAkC,AAC1B,uBAA0B,CACnC,AACD,8DACE,4CAA8C,AACtC,mCAAsC,CAC/C,AACD,2DACE,oDAAsD,AAC9C,2CAA8C,CACvD,AACD,8EACE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,0EACE,0CAA6C,AACrC,iCAAqC,CAC9C,AACD,kOAGE,SAAW,CACZ,AACD,2RAGE,gCAAiC,AACzB,uBAAyB,CAClC,AAaD;;;;qmBAYE,2BAA4B,AACpB,kBAAoB,CAC7B","file":"Home.vue","sourcesContent":["\n.option-group[data-v-7433356a] {\n  background: #fff;\n  width: 90%;\n  max-width: 400px;\n  height: 50px;\n  position: relative;\n  overflow: hidden;\n  border-radius: 0.25em;\n  font-size: 12px;\n  margin: 0.2em auto;\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n  top: -55px;\n}\n.option-container[data-v-7433356a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  width: 120%;\n  height: 100%;\n  margin: 0 -10%;\n}\n.option[data-v-7433356a] {\n  overflow: hidden;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  display: block;\n  padding: 0.5em;\n  background: #fff;\n  position: relative;\n  margin: 0em;\n  margin-right: 0.2em;\n  border-radius: 0.25em;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  cursor: pointer;\n  opacity: 0.5;\n  /* transition-duration: 0.8s, 0.6s; */\n  -webkit-transition-duration: 0.4s, 0.2s;\n          transition-duration: 0.4s, 0.2s;\n  -webkit-transition-property: opacity, -webkit-transform;\n  transition-property: opacity, -webkit-transform;\n  transition-property: transform, opacity;\n  transition-property: transform, opacity, -webkit-transform;\n  -webkit-transition-timing-function: cubic-bezier(0.98, 0, 0.22, 0.98), linear;\n          transition-timing-function: cubic-bezier(0.98, 0, 0.22, 0.98), linear;\n  will-change: transform, opacity;\n}\n.option[data-v-7433356a]:last-child {\n  margin-right: 0;\n}\n.option__indicator[data-v-7433356a] {\n  display: block;\n  -webkit-transform-origin: left bottom;\n          transform-origin: left bottom;\n  -webkit-transition: inherit;\n  transition: inherit;\n  will-change: transform;\n  position: absolute;\n  top: 0.5em;\n  right: 0.5em;\n  left: 0.5em;\n}\n/* .option__indicator:before,\n.option__indicator:after {\n  content: '';\n  display: block;\n  border: solid 2px #FFB733;\n  border-radius: 50%;\n  width: 0.25em;\n  height: 0.25em;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n .option__indicator:after {\n  background: #FFB733;\n  transform: scale(0);\n  transition: inherit;\n  will-change: transform;\n} */\n.option-input[data-v-7433356a] {\n  position: absolute;\n  top: 0;\n  z-index: -1;\n  visibility: hidden;\n}\n.option__label[data-v-7433356a] {\n  display: block;\n  width: 100%;\n  font-size: 1.5em;\n  font-weight: bold;\n  -webkit-transform-origin: left bottom;\n          transform-origin: left bottom;\n  -webkit-transform: translateX(20%) scale(0.7);\n          transform: translateX(20%) scale(0.7);\n  -webkit-transition: inherit;\n  transition: inherit;\n  will-change: transform;\n}\n.option__label sub[data-v-7433356a] {\n  margin-left: 0.25em;\n  /* font-size: 0.4em; */\n  font-size: 9px;\n  display: inline-block;\n  /* vertical-align: 0.3em; */\n  vertical-align: 10px;\n}\n.option__label[data-v-7433356a]:after {\n  content: \"\";\n  display: block;\n  border: solid 2px #4fb848;\n  width: 100%;\n  -webkit-transform-origin: 0 0;\n          transform-origin: 0 0;\n  -webkit-transform: scaleX(0.2);\n          transform: scaleX(0.2);\n  -webkit-transition: inherit;\n  transition: inherit;\n  will-change: transform;\n}\n.option:last-child .option__label[data-v-7433356a] {\n  -webkit-transform: translateX(0%) scale(0.7);\n          transform: translateX(0%) scale(0.7);\n}\n.option:last-child .option__indicator[data-v-7433356a] {\n  -webkit-transform: translateX(-20%);\n          transform: translateX(-20%);\n}\n.option-input:checked ~ .option[data-v-7433356a] {\n  -webkit-transform: translateX(-20%) translateX(0.2em);\n          transform: translateX(-20%) translateX(0.2em);\n}\n.option-input:checked ~ .option .option__indicator[data-v-7433356a] {\n  -webkit-transform: translateX(0%);\n          transform: translateX(0%);\n}\n.option-input:checked ~ .option .option__label[data-v-7433356a] {\n  -webkit-transform: translateX(40%) scale(0.7);\n          transform: translateX(40%) scale(0.7);\n}\n.option-input:first-child:checked ~ .option[data-v-7433356a] {\n  -webkit-transform: translateX(20%) translateX(-0.2em);\n          transform: translateX(20%) translateX(-0.2em);\n}\n.option-input:first-child:checked ~ .option .option__indicator[data-v-7433356a] {\n  -webkit-transform: translateX(-40%);\n          transform: translateX(-40%);\n}\n.option-input:first-child:checked ~ .option .option__label[data-v-7433356a] {\n  -webkit-transform: translateX(0%) scale(0.7);\n          transform: translateX(0%) scale(0.7);\n}\n.option-input:nth-child(1):checked ~ .option[data-v-7433356a]:nth-of-type(1),\n.option-input:nth-child(2):checked ~ .option[data-v-7433356a]:nth-of-type(2),\n.option-input:nth-child(3):checked ~ .option[data-v-7433356a]:nth-of-type(3) {\n  opacity: 1;\n}\n.option-input:nth-child(1):checked ~ .option:nth-of-type(1) .option__indicator[data-v-7433356a],\n.option-input:nth-child(2):checked ~ .option:nth-of-type(2) .option__indicator[data-v-7433356a],\n.option-input:nth-child(3):checked ~ .option:nth-of-type(3) .option__indicator[data-v-7433356a] {\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n}\n.option-input:nth-child(1):checked\n  ~ .option:nth-of-type(1)\n  .option__indicator[data-v-7433356a]::after,\n.option-input:nth-child(2):checked\n  ~ .option:nth-of-type(2)\n  .option__indicator[data-v-7433356a]::after,\n.option-input:nth-child(3):checked\n  ~ .option:nth-of-type(3)\n  .option__indicator[data-v-7433356a]::after {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.option-input:nth-child(1):checked ~ .option:nth-of-type(1) .option__label[data-v-7433356a],\n.option-input:nth-child(2):checked ~ .option:nth-of-type(2) .option__label[data-v-7433356a],\n.option-input:nth-child(3):checked ~ .option:nth-of-type(3) .option__label[data-v-7433356a],\n.option-input:nth-child(1):checked\n  ~ .option:nth-of-type(1)\n  .option__label[data-v-7433356a]::after,\n.option-input:nth-child(2):checked\n  ~ .option:nth-of-type(2)\n  .option__label[data-v-7433356a]::after,\n.option-input:nth-child(3):checked\n  ~ .option:nth-of-type(3)\n  .option__label[data-v-7433356a]::after {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiTrip_vue__ = __webpack_require__(814);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24951dbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiTrip_vue__ = __webpack_require__(1103);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiTrip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24951dbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiTrip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.mode === 'multi-trip' ? 'tab-pane in active' : 'tab-pane',attrs:{"id":"multiTrip"}},[_c('div',{staticClass:"search__box"},[_c('form',{attrs:{"id":"searchTransportation"},on:{"submit":function($event){$event.preventDefault();return _vm.search($event)}}},[_vm._l((_vm.trip),function(val,id){return _c('div',{key:id,staticClass:"wrapper-multi-form"},[(val === 'airport')?_c('div',{staticClass:"wrapper-airport-transfer"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-5 search--boxPhase-1"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[(_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              _vm.$v.searchRequest.pickUpLocation.name.$error,
                          },attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"airportPickUpLocation"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(1,true)]):_vm._e(),_vm._v(" "),(!_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              _vm.$v.searchRequest.pickUpLocation.name.$error,
                          },attrs:{"type":"text","autocomplete":"off","tabindex":"2","name":"airportPickUpLocation"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(2,true)]):_vm._e()]),_vm._v(" "),_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.dropOffLocation.name),expression:"searchRequest.dropOffLocation.name"}],staticClass:"searchBox__input searchBox__input-to",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              _vm.$v.searchRequest.dropOffLocation.name.$error,
                          },attrs:{"type":"text","autocomplete":"off","tabindex":"2","name":"airportDropOffLocation"},domProps:{"value":(_vm.searchRequest.dropOffLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.dropOffLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(4,true)]):_vm._e(),_vm._v(" "),(!_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.dropOffLocation.name),expression:"searchRequest.dropOffLocation.name"}],staticClass:"searchBox__input searchBox__input-to",class:{
                            'field-error':
                              _vm.isSubmitted &&
                              _vm.$v.searchRequest.dropOffLocation.name.$error,
                          },attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"airportDropOffLocation"},domProps:{"value":(_vm.searchRequest.dropOffLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.dropOffLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(5,true)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 search--boxPhase-2"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-date-checkin pl-5"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpDate","min-date":_vm.minimumPickUpDate,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.searchRequest.pickUpDate),callback:function ($$v) {_vm.$set(_vm.searchRequest, "pickUpDate", $$v)},expression:"searchRequest.pickUpDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpTime","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","minute-interval":"5","overlay":"","only-time":"","no-label":"","no-header":"","no-button":""},model:{value:(_vm.searchRequest.pickUpTime),callback:function ($$v) {_vm.$set(_vm.searchRequest, "pickUpTime", $$v)},expression:"searchRequest.pickUpTime"}})],1)])])])])])]):_c('div',{staticClass:"wrapper-hourly"},[_vm._m(6,true),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-4 search--boxPhase-1"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-12 pl-5"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequestHourly.pickUpLocation.name),expression:"searchRequestHourly.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.pickUpLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"1"},domProps:{"value":(_vm.searchRequestHourly.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequestHourly.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(7,true)]),_vm._v(" "),_vm._m(8,true)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 search--boxPhase-2"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-date-checkin pl-5"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"rentalRentDate","min-date":_vm.minimumRentDate,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.searchRequestHourly.rentDate),callback:function ($$v) {_vm.$set(_vm.searchRequestHourly, "rentDate", $$v)},expression:"searchRequestHourly.rentDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpTime","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","minute-interval":"15","overlay":"","only-time":"","no-label":"","no-header":"","no-button":""},model:{value:(_vm.searchRequestHourly.rentTime),callback:function ($$v) {_vm.$set(_vm.searchRequestHourly, "rentTime", $$v)},expression:"searchRequestHourly.rentTime"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 search--boxPhase-3"},[_c('div',{staticClass:"wrap__input-box",attrs:{"id":"rentTime-wrapper"}},[_c('div',{staticClass:"col-sm-12"},[_c('i',{staticClass:"ic-time plz"}),_vm._v(" "),_c('span',{staticClass:"searchBox__input"},[_vm._v("\n                        "+_vm._s(_vm.searchRequestHourly.durationInHour)+"\n                        "+_vm._s(_vm.searchRequestHourly.durationInHour === 1
                            ? "Hour"
                            : "Hours")+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"rentTime-box hidden"},[_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('h5',[_vm._v("\n                              Duration\n                              "),_c('span',[_vm._v(_vm._s(_vm.searchRequestHourly.durationInHour)+"\n                                "+_vm._s(_vm.searchRequestHourly.durationInHour === 1
                                    ? "Hour"
                                    : "Hours"))])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"col-sm-12 plz list-time"},[_c('ul',{staticClass:"picktime-hour"},_vm._l((_vm.durationValue),function(item,index){return _c('li',{key:index},[_c('a',{class:{
                                        selected:
                                          item ===
                                          _vm.searchRequestHourly.durationInHour,
                                      },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.onClickDurationPicker(item)}}},[_vm._v(_vm._s(item)+"\n                                      "+_vm._s(item === 1 ? "Hour" : "Hours"))])])}),0)])])])]),_vm._v(" "),_vm._m(9,true)])])])])])])])])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","disabled":!_vm.validateButton()}},[_vm._v("\n        Find Transportation\n      ")]),_vm._v(" "),_c('div',{staticClass:"button-add-wrapper"},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.pushTrip('airport')}}},[_vm._v("Tranfer")]),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.pushTrip('hourly')}}},[_vm._v("Hourly")])])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search__option-box"},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"depart-point"},[_vm._v("Address, Airport or Area")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pl-25"},[_c('label',{staticClass:"drop-point"},[_vm._v("Address, Airport or Area")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pl-5"},[_c('label',[_vm._v(" Pick-up Date ")]),_vm._v(" "),_c('span',{staticClass:"help-tip cursor-pointer",attrs:{"tabindex":"0","data-container":"body","data-toggle":"popover","data-placement":"top","data-content":"Local pick-up date."}},[_vm._v("\n                    ?\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',[_vm._v("Time")]),_vm._v(" "),_c('span',{staticClass:"help-tip cursor-pointer",attrs:{"tabindex":"0","data-container":"body","data-toggle":"popover","data-placement":"top","data-content":"Local pick-up time (please enter flight arrival time for airport pick-up)."}},[_vm._v("\n                    ?\n                  ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete pickup-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"pickup-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete pickup-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"pickup-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-But"},[_c('i',{staticClass:"ic-switch"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete dropoff-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"dropoff-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete dropoff-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"dropoff-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rental-search-label-box"},[_c('div',{staticClass:"search-location-label"},[_c('label',[_vm._v("Pickup Location")])]),_vm._v(" "),_c('div',{staticClass:"rental-date-label"},[_c('label',[_vm._v("Pickup Date & Time")])]),_vm._v(" "),_c('div',{staticClass:"rental-time-label"},[_c('label',[_vm._v("Duration")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"autoComplete-rentalResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 differ-box hidden"},[_c('i',{staticClass:"ic-marker-maps --grey50"}),_vm._v(" "),_c('div',{staticClass:"searchBox__input searchBox__input-to",attrs:{"tabindex":"2"}},[_vm._v("\n                        Surabaya\n                      ")]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"arrival"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crowen cBet"},[_c('div',{staticClass:"list-time-footer cBet"},[_c('a',{staticClass:"--orange75 apply-renttime",staticStyle:{"margin-left":"auto"},attrs:{"href":"javascript:void(0)"}},[_c('strong',[_vm._v("Apply")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.allowSearchInquiry || _vm.allowSearchInstant)?_c('section',{staticClass:"search-wrapper"},[_c('div',{staticClass:"jumbotron jumbo-bg",style:([
        _vm.bannerImage
          ? {
              background: ("#f4f4f9 url(" + _vm.bannerImage + ") no-repeat right center"),
              'background-size': 'contain',
            }
          : {} ])},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"option-group"},[_c('div',{staticClass:"option-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mode),expression:"mode"}],staticClass:"option-input",attrs:{"value":"airport-transfer","id":"search-mode-inquiry","type":"radio","name":"searchModeOptions"},domProps:{"checked":_vm._q(_vm.mode,"airport-transfer")},on:{"change":function($event){_vm.mode="airport-transfer"}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mode),expression:"mode"}],staticClass:"option-input",attrs:{"value":"rental","id":"search-mode-ondemand","type":"radio","name":"searchModeOptions"},domProps:{"checked":_vm._q(_vm.mode,"rental")},on:{"change":function($event){_vm.mode="rental"}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"main__search"},[_c('div',{staticClass:"tab-content"},[_c('rentalSearchForm',{attrs:{"mode":_vm.mode,"companies":_vm.companies,"services":_vm.permissions}}),_vm._v(" "),_c('airportTransferSearchForm',{attrs:{"mode":_vm.mode,"companies":_vm.companies,"services":_vm.permissions}}),_vm._v(" "),_c('multiTripForm',{attrs:{"mode":_vm.mode}})],1)])]):_vm._e(),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"content-wrapper hidden"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"option",attrs:{"for":"search-mode-inquiry"}},[_c('span',{staticClass:"option__indicator"}),_vm._v(" "),_c('span',{staticClass:"option__label"},[_vm._v("Transfer\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"option",attrs:{"for":"search-mode-ondemand"}},[_c('span',{staticClass:"option__indicator"}),_vm._v(" "),_c('span',{staticClass:"option__label"},[_vm._v("Hourly")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"}),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-right"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(813);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7433356a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(1104);
function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7433356a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7433356a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/companies';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  changeStatus: function changeStatus(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/status', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + '/' + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export arrayContainElement */
/* unused harmony export allowedPermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return allowToViewCustomerNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return allowToViewAdminNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return allowToAddEditAdminNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allowRepricingAirportTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return allowRepricingHourly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return companySelectorAirportTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return companySelectorHourly; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_constants__ = __webpack_require__(237);


var arrayContainElement = function arrayContainElement(arrayValue) {
  return arrayValue && arrayValue !== null;
};

var allowedPermission = function allowedPermission(currentUserPermission, permissionGroup, permission) {
  return arrayContainElement(currentUserPermission) && currentUserPermission[permissionGroup].includes(permission);
};

var allowToViewCustomerNotes = function allowToViewCustomerNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewCustomerNote");
};

var allowToViewAdminNotes = function allowToViewAdminNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewAdminNote");
};

var allowToAddEditAdminNotes = function allowToAddEditAdminNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "AddEditAdminNote");
};

var allowRepricingAirportTransfer = function allowRepricingAirportTransfer(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "Reprice") && allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewRepriceHistory");
};

var allowRepricingHourly = function allowRepricingHourly(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].HourlyReservation, "Reprice") && allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].HourlyReservation, "ViewRepriceHistory");
};

var companySelectorAirportTransfer = function companySelectorAirportTransfer(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].InquiryAvailability, "CompanySelector");
};

var companySelectorHourly = function companySelectorHourly(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].InstantAvailability, "CompanySelector");
};

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var _autocomplete;
var _sessionToken;
var _placesService;

var MaverickAutoComplete = function () {
  function MaverickAutoComplete() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MaverickAutoComplete);

    _autocomplete = new google.maps.places.AutocompleteService();
    _sessionToken = new google.maps.places.AutocompleteSessionToken();
    _placesService = new google.maps.places.PlacesService(document.createElement("div"));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MaverickAutoComplete, [{
    key: 'getPredictions',
    value: function getPredictions(keyword, callback, options) {
      if (!_sessionToken) {
        this.refreshToken();
      }
      // only trigger google service when char is more than equal to 3
      if (keyword.length >= 3) {
        var request = {
          input: keyword,
          sessionToken: _sessionToken
        };
        if (options && options.country) {
          request.componentRestrictions = {
            'country': options.country
          };
        }
        _autocomplete.getPlacePredictions(request, function (predictions, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            callback(predictions);
          }
        });
      }
    }
  }, {
    key: 'getPlace',
    value: function getPlace(prediction, callback) {
      var _this = this;

      var request = {
        placeId: prediction.place_id,
        fields: ['name', 'formatted_address', 'geometry', 'address_component'],
        sessionToken: _sessionToken
      };
      _placesService.getDetails(request, function (place, status) {
        // renew session token everytime place details has been requested
        _this.refreshToken();

        if (status === google.maps.places.PlacesServiceStatus.OK) {
          var country = '';
          for (var i = place.address_components.length - 1; i >= 0; i--) {
            if (place.address_components[i].types.find(function (x) {
              return x.toLowerCase() === 'country';
            }) !== undefined) {
              country = place.address_components[i].short_name;
              break;
            }
          }
          callback({
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            name: place.name,
            address: place.name + ', ' + place.formatted_address,
            country: country
          });
        }
      });
    }
  }, {
    key: 'refreshToken',
    value: function refreshToken() {
      _sessionToken = new google.maps.places.AutocompleteSessionToken();
    }
  }]);

  return MaverickAutoComplete;
}();

/* harmony default export */ __webpack_exports__["a"] = (MaverickAutoComplete);

/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_master_airportService_js__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_userHelper_js__ = __webpack_require__(531);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: { type: String, required: true },
    companies: { type: Array },
    services: { type: Object }
  },
  data: function data() {
    return {
      isSubmitted: false,
      airports: [],
      popularDestinations: [],
      isModified: false,
      isDepartureFromAirport: false,
      isAvoidCrossCity: false,
      minimumPickUpDate: null,
      maximumPickUpDate: null,
      refreshSessionInterval: null,
      searchClone: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        dropOffLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        }
      },
      searchRequest: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        dropOffLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        pickUpDate: null,
        pickUpTime: null,
        mode: "",
        company: null
      },
      permissions: null,
      companyOption: [],
      modifySearch: false
    };
  },
  validations: function validations() {
    return {
      searchRequest: {
        pickUpLocation: {
          name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
        },
        dropOffLocation: {
          name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
        },
        pickUpDate: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        pickUpTime: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
      }
    };
  },

  computed: {
    hasCompanySelector: function hasCompanySelector() {
      if (this.permissions) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_userHelper_js__["f" /* companySelectorAirportTransfer */])(this.permissions);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_userHelper_js__["f" /* companySelectorAirportTransfer */])(this.services);
    },
    departureAirports: function departureAirports() {
      if (this.searchRequest && this.searchRequest.pickUpLocation && this.searchRequest.pickUpLocation.name) {
        var pattern = new RegExp(this.searchRequest.pickUpLocation.name.toLowerCase(), "i");
        return this.airports.filter(function (airport) {
          return pattern.test(airport.air_code) || pattern.test(airport.air_name) || pattern.test(airport.ct_code) || pattern.test(airport.ct_name) || pattern.test(airport.cn_code) || pattern.test(airport.cn_name);
        });
      }
      return this.airports;
    },
    arrivalAirports: function arrivalAirports() {
      if (this.searchRequest && this.searchRequest.dropOffLocation && this.searchRequest.dropOffLocation.name) {
        var pattern = new RegExp(this.searchRequest.dropOffLocation.name.toLowerCase(), "i");
        return this.airports.filter(function (airport) {
          return pattern.test(airport.air_code) || pattern.test(airport.air_name) || pattern.test(airport.ct_code) || pattern.test(airport.ct_name) || pattern.test(airport.cn_code) || pattern.test(airport.cn_name);
        });
      }
      return this.airports;
    }
  },
  mounted: function mounted() {
    document.addEventListener("click", function (event) {
      var div = document.querySelector("#airportTransfer");
      if (div) {
        div.querySelectorAll(".list-autoComplete, .popularCity, .geolocationAirport").forEach(function (element) {
          return element.classList.remove("isOpen");
        });
      }
      if ($("#airportTransfer .searchBox__input-from, #airportTransfer .searchBox__input-to").is(event.target)) {
        var searchResult = $(event.target.parentElement).find(".list-autoComplete");
        var popularCity = $(event.target.parentElement).find(".popularCity");
        var geolocationAirport = $(event.target.parentElement).find(".geolocationAirport");

        if (searchResult.length > 0 && searchResult[0].getElementsByTagName("li").length > 0) {
          searchResult[0].classList.add("isOpen");
        } else if (popularCity.length > 0 && popularCity[0].getElementsByTagName("li").length > 0) {
          popularCity[0].classList.add("isOpen");
        } else if (geolocationAirport.length > 0 && geolocationAirport[0].getElementsByTagName("li").length > 0) {
          geolocationAirport[0].classList.add("isOpen");
        }
      }
    });

    document.addEventListener("keydown", this.handleEnter);
    $(".help-tip").popover({ trigger: "hover" });
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, userType, minDays, maxMonths, self, pickUpLocations, dropOffLocations;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("setting/getAllPublic");

            case 2:
              publicSettings = _context.sent;
              _context.next = 5;
              return _this.$store.dispatch("user/getProfile");

            case 5:
              profile = _context.sent;
              userType = profile.userType;
              minDays = userType === "TenantUser" ? 0 : parseInt(_this.$helper.extractSetting(publicSettings, "SearchMinDay", 0));
              maxMonths = userType === "TenantUser" ? 10000 : parseInt(_this.$helper.extractSetting(publicSettings, "BookingLimit", 0));


              _this.isAvoidCrossCity = _this.$helper.extractSetting(publicSettings, "AvoidCrossCity", "false") === "true";

              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_3__services_master_airportService_js__["a" /* default */].getAll();

            case 12:
              _this.airports = _context.sent;
              self = _this;
              // subscribe messages

              _this.$eventBus.$on("navigateToAirportTransfer", function () {
                return self.$parent.autocomplete.refreshToken();
              });
              _this.$eventBus.$on("bindAirportTransfer", _this.bindModelFromModifySearch);

              _this.refreshSessionInterval = setInterval(function () {
                self.$parent.autocomplete.refreshToken();
              }, 60000);

              pickUpLocations = _this.$helper.extractSetting(publicSettings, "AirportPickup", "-6.1275282|106.6537058|Soekarno-Hatta International Airport|Soekarno-Hatta International Airport, Tangerang City, Banten, Indonesia|ID|CGK").split("|");


              _this.searchRequest.pickUpLocation = {
                latitude: parseFloat(pickUpLocations[0]),
                longitude: parseFloat(pickUpLocations[1]),
                name: pickUpLocations[2],
                address: pickUpLocations[3],
                country: pickUpLocations[4]
              };

              _this.searchClone.pickUpLocation = {
                latitude: parseFloat(pickUpLocations[0]),
                longitude: parseFloat(pickUpLocations[1]),
                name: pickUpLocations[2],
                address: pickUpLocations[3],
                country: pickUpLocations[4]
              };

              if (pickUpLocations.length === 6) {
                _this.isDepartureFromAirport = true;
                _this.searchRequest.pickUpLocation.code = pickUpLocations[5];
                _this.searchRequest.pickUpLocation.isAirportZone = true;

                _this.searchClone.pickUpLocation.code = pickUpLocations[5];
                _this.searchClone.pickUpLocation.isAirportZone = true;
              }

              dropOffLocations = _this.$helper.extractSetting(publicSettings, "AirportDropoff", "-6.1767112|106.8306527|Gambir Station|Gambir Station, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia|ID").split("|");


              _this.searchRequest.dropOffLocation = {
                latitude: parseFloat(dropOffLocations[0]),
                longitude: parseFloat(dropOffLocations[1]),
                name: dropOffLocations[2],
                address: dropOffLocations[3],
                country: dropOffLocations[4]
              };

              _this.searchClone.dropOffLocation = {
                latitude: parseFloat(dropOffLocations[0]),
                longitude: parseFloat(dropOffLocations[1]),
                name: dropOffLocations[2],
                address: dropOffLocations[3],
                country: dropOffLocations[4]
              };

              if (dropOffLocations.length === 6) {
                _this.isDepartureFromAirport = false;
                _this.searchRequest.dropOffLocation.code = dropOffLocations[5];
                _this.searchRequest.dropOffLocation.isAirportZone = true;

                _this.searchClone.dropOffLocation.code = dropOffLocations[5];
                _this.searchClone.dropOffLocation.isAirportZone = true;
              }

              _this.searchRequest.pickUpDate = _this.$helper.toStringDate(_this.$helper.addDays(minDays));

              _this.searchRequest.pickUpTime = "10:00";

              _this.minimumPickUpDate = _this.$helper.toStringDate(_this.$helper.addDays(minDays));

              _this.maximumPickUpDate = _this.$helper.toStringDate(_this.$helper.addMonths(maxMonths));

              _this.popularDestinations = [
                // {
                //   name: "Soekarno-Hatta International Airport",
                //   address: "Soekarno-Hatta International Airport, Tangerang City, Banten, Indonesia",
                //   country: "ID",
                //   isAirportZone: true,
                //   lat: -6.127119,
                //   lng: 106.6534595,
                // },
                // {
                //   name: "Gambir Station",
                //   address: "Gambir Station, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia",
                //   country: "ID",
                //   isAirportZone: false,
                //   lat: -6.1767112,
                //   lng: 106.8306527,
                // },
                // {
                //   name: "Halim Perdana Kusuma",
                //   address: "Halim Perdana Kusuma, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia",
                //   country: "ID",
                //   isAirportZone: true,
                //   lat: -6.265208800000002,
                //   lng: 106.8863459,
                // },
              ];

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    // unsubscribe message
    this.$eventBus.$off("navigateToAirportTransfer");
    clearInterval(this.refreshSessionInterval);
    document.removeEventListener("keydown", this.handleEnter);
  },

  methods: {
    handleEnter: function handleEnter(e) {
      if (this.mode !== "airport-transfer") return;
      if (e.key !== "Enter") return;

      if (e.target.classList.contains("vs__search")) {
        return;
      }

      e.preventDefault();
      this.search();
    },
    swapLocation: function swapLocation() {
      var div = document.getElementById("airportTransfer");
      this.isDepartureFromAirport = !this.isDepartureFromAirport;

      // swap icon
      div.querySelector(".ic-switch").classList.toggle("onReverse");

      // swap location
      var tempLocation = this.searchRequest.pickUpLocation;
      this.searchRequest.pickUpLocation = this.searchRequest.dropOffLocation;
      this.searchRequest.dropOffLocation = tempLocation;

      // swap clone location
      var tempCloneLocation = this.searchClone.pickUpLocation;
      this.searchClone.pickUpLocation = this.searchClone.dropOffLocation;
      this.searchClone.dropOffLocation = tempCloneLocation;
    },
    bindModelFromModifySearch: function bindModelFromModifySearch(searchParameter, services, companies, modifySearch) {
      this.isModified = true;

      this.permissions = services;
      this.companyOption = companies;
      this.modifySearch = modifySearch;
      this.searchRequest = {
        pickUpLocation: {
          latitude: searchParameter.pickUpLocation.latitude,
          longitude: searchParameter.pickUpLocation.longitude,
          code: searchParameter.pickUpLocation.code,
          name: searchParameter.pickUpLocation.name,
          address: searchParameter.pickUpLocation.address,
          country: searchParameter.pickUpLocation.country,
          isAirportZone: searchParameter.pickUpLocation.isAirportZone
        },
        dropOffLocation: {
          latitude: searchParameter.dropOffLocation.latitude,
          longitude: searchParameter.dropOffLocation.longitude,
          code: searchParameter.dropOffLocation.code,
          name: searchParameter.dropOffLocation.name,
          address: searchParameter.dropOffLocation.address,
          country: searchParameter.dropOffLocation.country,
          isAirportZone: searchParameter.dropOffLocation.isAirportZone
        },
        pickUpDate: this.$helper.toDateString(searchParameter.pickUpDateTime, "YYYY-MM-DD"),
        pickUpTime: this.$helper.toDateString(searchParameter.pickUpDateTime, "HH:mm"),
        mode: searchParameter.mode,
        company: searchParameter.companyId
      };

      this.searchClone = {
        pickUpLocation: {
          latitude: searchParameter.pickUpLocation.latitude,
          longitude: searchParameter.pickUpLocation.longitude,
          code: searchParameter.pickUpLocation.code,
          name: searchParameter.pickUpLocation.name,
          address: searchParameter.pickUpLocation.address,
          country: searchParameter.pickUpLocation.country,
          isAirportZone: searchParameter.pickUpLocation.isAirportZone
        },
        dropOffLocation: {
          latitude: searchParameter.dropOffLocation.latitude,
          longitude: searchParameter.dropOffLocation.longitude,
          code: searchParameter.dropOffLocation.code,
          name: searchParameter.dropOffLocation.name,
          address: searchParameter.dropOffLocation.address,
          country: searchParameter.dropOffLocation.country,
          isAirportZone: searchParameter.dropOffLocation.isAirportZone
        }
      };

      // indicates whether departure using geolocation or google maps autocomplete
      this.isDepartureFromAirport = this.searchRequest.pickUpLocation.code !== undefined;
    },
    onKeyupAirportGeolocation: function onKeyupAirportGeolocation(target) {
      target.parentElement.querySelector(".geolocationAirport").classList.add("isOpen");
    },
    onClickAirportGeolocation: function onClickAirportGeolocation(airport, target) {
      switch (target) {
        case "pickup":
          this.searchRequest.pickUpLocation = {
            latitude: airport.lat,
            longitude: airport.long,
            code: airport.air_code,
            name: airport.air_name,
            address: airport.air_name,
            country: airport.cn_code
          };
          break;
        case "dropoff":
          this.searchRequest.dropOffLocation = {
            latitude: airport.lat,
            longitude: airport.long,
            code: airport.air_code,
            name: airport.air_name,
            address: airport.air_name,
            country: airport.cn_code
          };
          break;
      }
    },
    onClickPopularDestination: function onClickPopularDestination(popular, target) {
      switch (target) {
        case "pickup":
          this.searchRequest.pickUpLocation = {
            latitude: popular.lat,
            longitude: popular.lng,
            name: popular.name,
            address: popular.address,
            country: popular.country,
            isAirportZone: popular.isAirportZone
          };
          break;
        case "dropoff":
          this.searchRequest.dropOffLocation = {
            latitude: popular.lat,
            longitude: popular.lng,
            name: popular.name,
            address: popular.address,
            country: popular.country,
            isAirportZone: popular.isAirportZone
          };
          break;
      }
    },
    onFocusAutoComplete: function onFocusAutoComplete(target) {
      target.value = "";
    },
    onBlurAutoComplete: function onBlurAutoComplete(target) {
      switch (target.name) {
        case "airportPickUpLocation":
          target.value = this.searchRequest.pickUpLocation.name;
          var isEqualPickUpLocation = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(this.searchRequest.pickUpLocation, this.searchClone.pickUpLocation);
          if (!isEqualPickUpLocation) {
            this.searchRequest.pickUpLocation.name = "";
          }
          break;
        case "airportDropOffLocation":
          target.value = this.searchRequest.dropOffLocation.name;
          var isEqualDropOffLocation = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(this.searchRequest.dropOffLocation, this.searchClone.dropOffLocation);
          if (!isEqualDropOffLocation) {
            this.searchRequest.dropOffLocation.name = "";
          }
          break;
      }
    },
    onKeyupAutoComplete: function onKeyupAutoComplete(target) {
      var _this2 = this;

      document.querySelectorAll(".popularCity").forEach(function (element) {
        return element.classList.remove("isOpen");
      });

      var self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(function (_) {
        var autoCompleteResultElement = null;
        var options = {};
        var prefix = "";
        switch (target.name) {
          case "airportPickUpLocation":
            autoCompleteResultElement = document.getElementById("pickup-airportAutoCompleteResults");
            //options.country = self.searchRequest.dropOffLocation.country;
            if (self.isAvoidCrossCity) {
              var airport = _this2.airports.find(function (x) {
                return x.air_code === self.searchRequest.dropOffLocation.code;
              });
              if (airport) {
                prefix = airport.ct_name + ", ";
              }
            }
            break;
          case "airportDropOffLocation":
            autoCompleteResultElement = document.getElementById("dropoff-airportAutoCompleteResults");
            // options.country = self.searchRequest.pickUpLocation.country;
            if (self.isAvoidCrossCity) {
              var _airport = _this2.airports.find(function (x) {
                return x.air_code === self.searchRequest.pickUpLocation.code;
              });
              if (_airport) {
                prefix = _airport.ct_name + ", ";
              }
            }
            break;
        }
        // reset suggestion result
        autoCompleteResultElement.innerHTML = "";

        // handle empty pick-up location keyword
        if (target.value === "") {
          autoCompleteResultElement.parentElement.classList.remove("isOpen");
          return;
        }

        self.$parent.autocomplete.getPredictions("" + prefix + target.value, function (predictions) {
          // loop result
          predictions.forEach(function (prediction) {
            var item = document.createElement("li");
            item.innerHTML = self.$helper.getPlaceIcon(prediction.types, prediction.description) + "<div class='point-of-view'>" + prediction.structured_formatting.main_text + "</div>" + "<span>" + prediction.structured_formatting.secondary_text + "</span>";
            item.addEventListener("click", function (_) {
              return self.getPlace(target, prediction);
            });
            autoCompleteResultElement.appendChild(item);
          });
          // show the result
          autoCompleteResultElement.parentElement.classList.add("isOpen");
        }, options);
      }, 200);
    },
    getPlace: function getPlace(target, prediction) {
      var self = this;
      var result = null;
      self.$parent.autocomplete.getPlace(prediction, function (place) {
        var isAirportZone = prediction.types.includes("airport") || prediction.description.toLowerCase().includes("airport") ? true : false;

        switch (target.name) {
          case "airportPickUpLocation":
            result = document.getElementById("pickup-airportAutoCompleteResults");
            self.searchRequest.pickUpLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            self.searchClone.pickUpLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            self.handleDifferentCountry();
            break;
          case "airportDropOffLocation":
            result = document.getElementById("dropoff-airportAutoCompleteResults");
            self.searchRequest.dropOffLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            self.searchClone.dropOffLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            break;
        }
        // everytime user select the prediction, result list should be reset
        result.innerHTML = "";
      });
    },
    buildQueryParam: function buildQueryParam(request) {
      var queryParam = {};

      // pick-up
      queryParam.plt = request.pickUpLocation.latitude;
      queryParam.plg = request.pickUpLocation.longitude;
      queryParam.pcd = request.pickUpLocation.code;
      queryParam.pad = request.pickUpLocation.address;
      queryParam.pnm = request.pickUpLocation.name;
      queryParam.pcn = request.pickUpLocation.country ? request.pickUpLocation.country : request.dropOffLocation.country;
      queryParam.pia = request.pickUpLocation.isAirportZone;

      // drop-off
      queryParam.dlt = request.dropOffLocation.latitude;
      queryParam.dlg = request.dropOffLocation.longitude;
      queryParam.dcd = request.dropOffLocation.code;
      queryParam.dad = request.dropOffLocation.address;
      queryParam.dnm = request.dropOffLocation.name;
      queryParam.dcn = request.dropOffLocation.country ? request.dropOffLocation.country : request.pickUpLocation.country;
      queryParam.dia = request.dropOffLocation.isAirportZone;

      // start rent
      queryParam.ptm = request.pickUpDateTime.year + "." + request.pickUpDateTime.month + "." + request.pickUpDateTime.day + "-" + request.pickUpDateTime.hour + "." + request.pickUpDateTime.minute;

      // service type
      queryParam.svc = "airporttransfer";

      // HACK: handle duplication routing
      queryParam.ver = Math.random().toString(36).substr(2, 9);

      // search mode
      queryParam.mode = request.mode;

      // companyId
      queryParam.company = request.company;

      return queryParam;
    },
    search: function search() {
      this.isSubmitted = true;
      this.$v.searchRequest.$touch();
      if (this.$v.searchRequest.$error) {
        return;
      }
      // parse datetime
      if (this.searchRequest.pickUpDate && this.searchRequest.pickUpTime) {
        var pickUpDates = this.searchRequest.pickUpDate.split("-");
        var pickUpTimes = this.searchRequest.pickUpTime.split(":");
        this.searchRequest.pickUpDateTime = {
          year: parseInt(pickUpDates[0]),
          month: parseInt(pickUpDates[1]),
          day: parseInt(pickUpDates[2]),
          hour: parseInt(pickUpTimes[0]),
          minute: parseInt(pickUpTimes[1])
        };

        // this.searchRequest.mode = this.mode;
        this.searchRequest.mode = "Inquiry";

        if (this.searchRequest.mode === "Inquiry") {
          if (this.isModified) {
            this.$eventBus.$emit("executeModifySearch", this.buildQueryParam(this.searchRequest));
          } else {
            this.$router.push({
              path: "/availability/inquiry",
              query: this.buildQueryParam(this.searchRequest)
            });
          }
        } else {
          if (this.isModified) {
            this.$eventBus.$emit("executeModifySearch", this.buildQueryParam(this.searchRequest));
          } else {
            this.$router.push({
              path: "/availability/instant",
              query: this.buildQueryParam(this.searchRequest)
            });
          }
        }
      }
    },
    handleDifferentCountry: function handleDifferentCountry() {
      if (this.searchRequest.pickUpLocation.country != this.searchRequest.dropOffLocation.country) {
        this.searchRequest.dropOffLocation = {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0
        };

        var dropOffTextbox = document.getElementsByName("airportDropOffLocation")[0];

        if (dropOffTextbox) {
          dropOffTextbox.click();
          dropOffTextbox.focus();
        }
      }
    },
    validateButton: function validateButton() {
      return this.searchRequest.pickUpLocation.name && this.searchRequest.dropOffLocation.name;
    }
  }
});

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/airports';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_userHelper_js__ = __webpack_require__(531);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: { type: String, required: true },
    companies: { type: Array },
    services: { type: Object }
  },
  data: function data() {
    return {
      isSubmitted: false,
      isModifySearch: false,
      pickUpHours: [],
      pickUpMinutes: [],
      dropOffHours: [],
      dropOffMinutes: [],
      minimumRentDate: null,
      maximumRentDate: null,
      refreshSessionInterval: null,
      durationValue: [],
      searchRequest: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        rentDate: null,
        rentTime: null,
        durationInHour: null,
        isSelfDrive: false,
        mode: "",
        company: null
      },
      permissions: null,
      companyOption: [],
      modifySearch: false
    };
  },
  validations: function validations() {
    return {
      searchRequest: {
        pickUpLocation: { name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] } },
        rentDate: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        rentTime: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        durationInHour: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
      }
    };
  },

  computed: {
    hasCompanySelector: function hasCompanySelector() {
      if (this.permissions) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_userHelper_js__["g" /* companySelectorHourly */])(this.permissions);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_userHelper_js__["g" /* companySelectorHourly */])(this.services);
    }
  },
  mounted: function mounted() {
    var toggler = document.getElementsByClassName("toggle-box")[0];
    var self = this;
    if (toggler) {
      document.getElementsByClassName("toggle-wrapper")[0].addEventListener("click", function (event) {
        self.searchRequest.isSelfDrive = !toggler.classList.toggle("active");
      });
    }
    document.addEventListener("click", function (event) {
      $.each($("#carSearch .list-autoComplete, #carSearch .popularCity"), function (index, value) {
        value.classList.remove("isOpen");
      });

      if ($("#carSearch .searchBox__input-from").is(event.target)) {
        var searchResult = $(event.target.parentElement).find(".list-autoComplete");
        var popularCity = $(event.target.parentElement).find(".popularCity");
        if (searchResult.length > 0 && searchResult[0].getElementsByTagName("li").length > 0) {
          searchResult[0].classList.add("isOpen");
        } else if (popularCity.length > 0 && popularCity[0].getElementsByTagName("li").length > 0) {
          popularCity[0].classList.add("isOpen");
        }
      }

      // toggle rentTime-box
      var rentTimeWrapper = document.querySelector("#rentTime-wrapper");
      if (rentTimeWrapper) {
        if (rentTimeWrapper.contains(event.target) && !event.target.parentElement.classList.contains("apply-renttime")) {
          document.querySelector(".rentTime-box").classList.remove("hidden");
        } else {
          document.querySelector(".rentTime-box").classList.add("hidden");
        }
      }
    });

    document.addEventListener("keydown", this.handleEnter);
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, userType, minHourly, tempDurationList, i, minDays, maxMonths, self, defaultHour, defaultMinute, pickUpLocations;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("setting/getAllPublic");

            case 2:
              publicSettings = _context.sent;
              _context.next = 5;
              return _this.$store.dispatch("user/getProfile");

            case 5:
              profile = _context.sent;
              userType = profile.userType;
              minHourly = publicSettings.find(function (val) {
                return val.key === "MinimumHourlyHire";
              });
              tempDurationList = [];

              for (i = minHourly.value; i <= 24; i++) {
                tempDurationList.push(Number(i));
              }
              _this.durationValue = tempDurationList;
              minDays = userType === "TenantUser" ? 0 : parseInt(_this.$helper.extractSetting(publicSettings, "SearchMinDay", 0));
              maxMonths = userType === "TenantUser" ? 10000 : parseInt(_this.$helper.extractSetting(publicSettings, "BookingLimit", 0));

              // const country = this.$helper.extractSetting(
              //   publicSettings,
              //   "CountryHours",
              //   0
              // );

              self = _this;
              // subscribe messages

              _this.$eventBus.$on("navigateToVehicleRental", function () {
                self.$parent.autocomplete.refreshToken();
              });
              _this.$eventBus.$on("bindVehicleRental", _this.bindModelFromModifySearch);

              _this.refreshSessionInterval = setInterval(function () {
                self.$parent.autocomplete.refreshToken();
              }, 60000);

              defaultHour = 10;
              defaultMinute = 0;


              _this.minimumRentDate = _this.$helper.toStringDate(_this.$helper.addDays(minDays));

              _this.maximumRentDate = _this.$helper.toStringDate(_this.$helper.addMonths(maxMonths));

              pickUpLocations = _this.$helper.extractSetting(publicSettings, "RentalPickup", "-6.2023616|106.8119382|National Monument|National Monument, Gambir, Central Jakarta City, Jakarta, Indonesia|ID").split("|");


              _this.searchRequest = {
                pickUpLocation: {
                  latitude: parseFloat(pickUpLocations[0]),
                  longitude: parseFloat(pickUpLocations[1]),
                  name: pickUpLocations[2],
                  address: pickUpLocations[3],
                  country: pickUpLocations[4],
                  isAirportZone: false
                },
                rentDate: _this.$helper.toStringDate(_this.$helper.addDays(minDays)),
                rentTime: defaultHour + ":0" + defaultMinute,
                durationInHour: Number(minHourly.value) || 1,
                isSelfDrive: false
              };

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    // unsubscribe message
    this.$eventBus.$off("navigateToVehicleRental");
    clearInterval(this.refreshSessionInterval);
    document.removeEventListener("keydown", this.handleEnter);
  },

  methods: {
    handleEnter: function handleEnter(e) {
      if (this.mode !== "rental") return;
      if (e.key !== "Enter") return;

      if (e.target.classList.contains("vs__search")) {
        return;
      }

      e.preventDefault();
      this.search();
    },
    bindModelFromModifySearch: function bindModelFromModifySearch(searchParameter, services, companies, modifySearch) {
      this.permissions = services;
      this.companyOption = companies;
      this.modifySearch = modifySearch;
      this.searchRequest = {
        pickUpLocation: {
          latitude: searchParameter.location.latitude,
          longitude: searchParameter.location.longitude,
          name: searchParameter.location.name,
          address: searchParameter.location.address,
          country: searchParameter.location.country
        },
        rentDate: this.$helper.toDateString(searchParameter.startRent, "YYYY-MM-DD"),
        rentTime: searchParameter.startRent.hour + ":" + searchParameter.startRent.minute,
        durationInHour: Number(searchParameter.durationInHour),
        isSelfDrive: searchParameter.isSelfDrive,
        mode: searchParameter.mode,
        company: searchParameter.companyId || null
      };

      this.isModifySearch = true;
    },
    onClickDurationPicker: function onClickDurationPicker(hours) {
      this.searchRequest.durationInHour = hours;
    },
    onFocusAutoComplete: function onFocusAutoComplete(target) {
      target.value = "";
    },
    onBlurAutoComplete: function onBlurAutoComplete(target) {
      target.value = this.searchRequest.pickUpLocation.name;
    },
    onKeyupAutoComplete: function onKeyupAutoComplete(target) {
      document.querySelectorAll(".popularCity").forEach(function (element) {
        return element.classList.remove("isOpen");
      });

      var self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(function (_) {
        var element = document.getElementById("autoComplete-rentalResults");

        // reset suggestion result
        element.innerHTML = "";

        // handle empty pick-up location keyword
        if (target.value === "") {
          element.parentElement.classList.remove("isOpen");
          return;
        }
        self.$parent.autocomplete.getPredictions(target.value, function (predictions) {
          // loop result
          predictions.forEach(function (prediction) {
            var item = document.createElement("li");
            item.innerHTML = self.$helper.getPlaceIcon(prediction.types, prediction.description) + "<div class='point-of-view'>" + prediction.structured_formatting.main_text + "</div><span>" + prediction.structured_formatting.secondary_text + "</span>";
            item.addEventListener("click", function (_) {
              return self.getPlace(prediction);
            });
            element.appendChild(item);
          });
          // show the result
          element.parentElement.classList.add("isOpen");
        });
      }, 200);
    },
    getPlace: function getPlace(prediction) {
      var self = this;
      self.$parent.autocomplete.getPlace(prediction, function (place) {
        var isAirportZone = prediction.types.includes("airport") || prediction.description.toLowerCase().includes("airport") ? true : false;
        self.searchRequest.pickUpLocation = {
          latitude: place.latitude,
          longitude: place.longitude,
          name: place.name,
          address: place.address,
          country: place.country,
          isAirportZone: isAirportZone
        };
        // everytime user select the prediction, result list should be reset
        document.getElementById("autoComplete-rentalResults").innerHTML = "";
      });
    },
    buildQueryParam: function buildQueryParam(request) {
      var queryParam = {};

      // pick-up location (coordinate & address)
      queryParam.plt = request.pickUpLocation.latitude;
      queryParam.plg = request.pickUpLocation.longitude;
      queryParam.pad = request.pickUpLocation.address;
      queryParam.pnm = request.pickUpLocation.name;
      queryParam.pcn = request.pickUpLocation.country;
      queryParam.pia = request.pickUpLocation.isAirportZone;

      // start rent
      queryParam.str = request.startRent.year + "." + request.startRent.month + "." + request.startRent.day + "-" + request.startRent.hour + "." + request.startRent.minute;

      // end rent
      // queryParam.enr = `${request.endRent.year}.${request.endRent.month}.${request.endRent.day}-${request.endRent.hour}.${request.endRent.minute}`;

      // with driver / self drive
      queryParam.slf = request.isSelfDrive;

      // service type
      queryParam.duration = request.durationInHour;

      // service type
      queryParam.svc = "rental";

      // HACK: handle duplication routing
      queryParam.ver = Math.random().toString(36).substr(2, 9);

      // search mode
      queryParam.mode = request.mode;

      // companyId
      queryParam.company = request.company;

      return queryParam;
    },
    search: function search() {
      this.isSubmitted = true;
      this.$v.searchRequest.$touch();
      if (this.$v.searchRequest.$error) {
        return;
      }
      // parse datetime
      if (this.searchRequest.rentDate && this.searchRequest.rentTime && this.searchRequest.durationInHour) {
        var startRentDates = this.searchRequest.rentDate.split("-");
        var startRentTimes = this.searchRequest.rentTime.split(":");
        this.searchRequest.startRent = {
          year: parseInt(startRentDates[0]),
          month: parseInt(startRentDates[1]),
          day: parseInt(startRentDates[2]),
          hour: parseInt(startRentTimes[0]),
          minute: parseInt(startRentTimes[1])
        };

        this.searchRequest.mode = "Inquiry";

        if (this.searchRequest.mode === "Inquiry") {
          if (this.isModifySearch) {
            this.$eventBus.$emit("executeModifySearchRental", this.buildQueryParam(this.searchRequest));
          } else {
            this.$router.push({
              path: "/availability/inquiry",
              query: this.buildQueryParam(this.searchRequest)
            });
          }
        } else {
          if (this.isModifySearch) {
            this.$eventBus.$emit("executeModifySearchRental", this.buildQueryParam(this.searchRequest));
          } else {
            this.$router.push({
              path: "/availability/instant",
              query: this.buildQueryParam(this.searchRequest)
            });
          }
        }
      }
    }
  }
});

/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transfer_vue__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216ed9e3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transfer_vue__ = __webpack_require__(606);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216ed9e3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.mode === 'airport-transfer' ? 'tab-pane in active' : 'tab-pane',attrs:{"id":"airportTransfer"}},[_c('div',{staticClass:"search__box"},[(_vm.modifySearch)?_c('button',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('closeModal')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34z","fill":"currentColor"}})])]):_vm._e(),_vm._v(" "),_c('form',{attrs:{"id":"searchTransportation"},on:{"submit":function($event){$event.preventDefault();return _vm.search($event)}}},[(_vm.hasCompanySelector)?[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-12 search--boxPhase-1"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[(_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.pickUpLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"airportPickUpLocation"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),(!_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.pickUpLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"2","name":"airportPickUpLocation"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"switch-But",on:{"click":function($event){return _vm.swapLocation()}}},[_c('i',{staticClass:"ic-switch"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.dropOffLocation.name),expression:"searchRequest.dropOffLocation.name"}],staticClass:"searchBox__input searchBox__input-to",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.dropOffLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"2","name":"airportDropOffLocation"},domProps:{"value":(_vm.searchRequest.dropOffLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.dropOffLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.dropOffLocation.name),expression:"searchRequest.dropOffLocation.name"}],staticClass:"searchBox__input searchBox__input-to",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.dropOffLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"airportDropOffLocation"},domProps:{"value":(_vm.searchRequest.dropOffLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.dropOffLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(4)]):_vm._e()])])])])])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-8 search--boxPhase-2"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-date-checkin pl-5"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpDate","min-date":_vm.minimumPickUpDate,"max-date":_vm.maximumPickUpDate,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD, YYYY","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.searchRequest.pickUpDate),callback:function ($$v) {_vm.$set(_vm.searchRequest, "pickUpDate", $$v)},expression:"searchRequest.pickUpDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpTime","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","minute-interval":"5","overlay":"","only-time":"","no-label":"","no-header":"","no-button":""},model:{value:(_vm.searchRequest.pickUpTime),callback:function ($$v) {_vm.$set(_vm.searchRequest, "pickUpTime", $$v)},expression:"searchRequest.pickUpTime"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 search--boxPhase-3"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"padding":"0"}},[_c('v-select',{staticClass:"v-search-select airport-trr-select",attrs:{"id":"airport-trr-select","placeholder":"Select Company","label":"name","disabled":!_vm.hasCompanySelector,"options":_vm.companies || _vm.companyOption,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; }},model:{value:(_vm.searchRequest.company),callback:function ($$v) {_vm.$set(_vm.searchRequest, "company", $$v)},expression:"searchRequest.company"}})],1)])])])])]:[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox",attrs:{"id":"inline-search-inputBox"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-5 search--boxPhase-1"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[(_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.pickUpLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"airportPickUpLocation"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(7)]):_vm._e(),_vm._v(" "),(!_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.pickUpLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"2","name":"airportPickUpLocation"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(8)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"switch-But",on:{"click":function($event){return _vm.swapLocation()}}},[_c('i',{staticClass:"ic-switch"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.dropOffLocation.name),expression:"searchRequest.dropOffLocation.name"}],staticClass:"searchBox__input searchBox__input-to",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.dropOffLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"2","name":"airportDropOffLocation"},domProps:{"value":(_vm.searchRequest.dropOffLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.dropOffLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(9)]):_vm._e(),_vm._v(" "),(!_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.dropOffLocation.name),expression:"searchRequest.dropOffLocation.name"}],staticClass:"searchBox__input searchBox__input-to",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.dropOffLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"airportDropOffLocation"},domProps:{"value":(_vm.searchRequest.dropOffLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.dropOffLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(10)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 search--boxPhase-2"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-date-checkin pl-5"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpDate","min-date":_vm.minimumPickUpDate,"max-date":_vm.maximumPickUpDate,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.searchRequest.pickUpDate),callback:function ($$v) {_vm.$set(_vm.searchRequest, "pickUpDate", $$v)},expression:"searchRequest.pickUpDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpTime","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","minute-interval":"5","overlay":"","only-time":"","no-label":"","no-header":"","no-button":""},model:{value:(_vm.searchRequest.pickUpTime),callback:function ($$v) {_vm.$set(_vm.searchRequest, "pickUpTime", $$v)},expression:"searchRequest.pickUpTime"}})],1)])])])])])],_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","disabled":!_vm.validateButton()}},[_vm._v("\n        Find Transportation\n      ")])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search__option-box"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"depart-point"},[_vm._v("Address, Airport or Area")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",staticStyle:{"padding-left":"35px"}},[_c('label',{staticClass:"drop-point"},[_vm._v("Address, Airport or Area")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete pickup-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"pickup-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete pickup-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"pickup-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete dropoff-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"dropoff-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete dropoff-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"dropoff-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search__option-box"},[_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('label',[_vm._v(" Pick-up Date ")]),_vm._v(" "),_c('span',{staticClass:"help-tip cursor-pointer",attrs:{"tabindex":"0","data-container":"body","data-toggle":"popover","data-placement":"top","data-content":"Local pick-up date."}},[_vm._v("\n                  ?\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',[_vm._v("Time")]),_vm._v(" "),_c('span',{staticClass:"help-tip cursor-pointer",attrs:{"tabindex":"0","data-container":"body","data-toggle":"popover","data-placement":"top","data-content":"Local pick-up time (please enter flight arrival time for airport pick-up)."}},[_vm._v("\n                  ?\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pl-5"},[_c('label',[_vm._v(" Company ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search__option-box",attrs:{"id":"inline-search-optionBox"}},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"depart-point"},[_vm._v("Address, Airport or Area")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pl-25"},[_c('label',{staticClass:"drop-point"},[_vm._v("Address, Airport or Area")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pl-5"},[_c('label',[_vm._v(" Pick-up Date ")]),_vm._v(" "),_c('span',{staticClass:"help-tip cursor-pointer",attrs:{"tabindex":"0","data-container":"body","data-toggle":"popover","data-placement":"top","data-content":"Local pick-up date."}},[_vm._v("\n                  ?\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',[_vm._v("Time")]),_vm._v(" "),_c('span',{staticClass:"help-tip cursor-pointer",attrs:{"tabindex":"0","data-container":"body","data-toggle":"popover","data-placement":"top","data-content":"Local pick-up time (please enter flight arrival time for airport pick-up)."}},[_vm._v("\n                  ?\n                ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete pickup-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"pickup-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete pickup-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"pickup-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete dropoff-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"dropoff-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete dropoff-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"dropoff-airportAutoCompleteResults"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rental_vue__ = __webpack_require__(591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74f4497e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rental_vue__ = __webpack_require__(608);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rental_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74f4497e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rental_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.mode === 'rental' ? 'tab-pane in active' : 'tab-pane',attrs:{"id":"carSearch"}},[_c('div',{staticClass:"search__box"},[(_vm.modifySearch)?_c('button',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('closeModal')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34z","fill":"currentColor"}})])]):_vm._e(),_vm._v(" "),_c('form',{attrs:{"id":"searchRental"},on:{"submit":function($event){$event.preventDefault();return _vm.search($event)}}},[(_vm.hasCompanySelector)?[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-6 search--boxPhase-1"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-12 pl-5"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                        'field-error':
                          _vm.isSubmitted &&
                          _vm.$v.searchRequest.pickUpLocation.name.$error,
                      },attrs:{"type":"text","autocomplete":"off","tabindex":"1"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 search--boxPhase-3"},[_c('div',{staticClass:"wrap__input-box",attrs:{"id":"rentTime-wrapper"}},[_c('div',{staticClass:"col-sm-12"},[_c('i',{staticClass:"ic-time plz"}),_vm._v(" "),_c('span',{staticClass:"searchBox__input"},[_vm._v("\n                      "+_vm._s(_vm.searchRequest.durationInHour)+"\n                      "+_vm._s(_vm.searchRequest.durationInHour === 1 ? "Hour" : "Hours")+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"rentTime-box hidden"},[_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('h5',[_vm._v("\n                            Duration\n                            "),_c('span',[_vm._v(_vm._s(_vm.searchRequest.durationInHour)+"\n                              "+_vm._s(_vm.searchRequest.durationInHour === 1
                                  ? "Hour"
                                  : "Hours"))])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"col-sm-12 plz list-time"},[_c('ul',{staticClass:"picktime-hour"},_vm._l((_vm.durationValue),function(item,index){return _c('li',{key:index},[_c('a',{class:{
                                      selected:
                                        item === _vm.searchRequest.durationInHour,
                                    },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.onClickDurationPicker(item)}}},[_vm._v(_vm._s(item)+"\n                                    "+_vm._s(item === 1 ? "Hour" : "Hours"))])])}),0)])])])]),_vm._v(" "),_vm._m(3)])])])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-6 search--boxPhase-3"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-date-checkin pl-5"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"rentalRentDate","min-date":_vm.minimumRentDate,"max-date":_vm.maximumRentDate,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD, YYYY","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.searchRequest.rentDate),callback:function ($$v) {_vm.$set(_vm.searchRequest, "rentDate", $$v)},expression:"searchRequest.rentDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpTime","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","minute-interval":"15","overlay":"","only-time":"","no-label":"","no-header":"","no-button":""},model:{value:(_vm.searchRequest.rentTime),callback:function ($$v) {_vm.$set(_vm.searchRequest, "rentTime", $$v)},expression:"searchRequest.rentTime"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 search--boxPhase-2"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"padding":"0"}},[_c('v-select',{staticClass:"v-search-select airport-trr-select",attrs:{"id":"airport-trr-select","placeholder":"Select Company","label":"name","disabled":!_vm.hasCompanySelector,"options":_vm.companies || _vm.companyOption,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; }},model:{value:(_vm.searchRequest.company),callback:function ($$v) {_vm.$set(_vm.searchRequest, "company", $$v)},expression:"searchRequest.company"}})],1)])])])])]:[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-4 search--boxPhase-1"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-12 pl-5"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                        'field-error':
                          _vm.isSubmitted &&
                          _vm.$v.searchRequest.pickUpLocation.name.$error,
                      },attrs:{"type":"text","autocomplete":"off","tabindex":"1"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 search--boxPhase-2"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-date-checkin pl-5"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"rentalRentDate","min-date":_vm.minimumRentDate,"max-date":_vm.maximumRentDate,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.searchRequest.rentDate),callback:function ($$v) {_vm.$set(_vm.searchRequest, "rentDate", $$v)},expression:"searchRequest.rentDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpTime","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","minute-interval":"15","overlay":"","only-time":"","no-label":"","no-header":"","no-button":""},model:{value:(_vm.searchRequest.rentTime),callback:function ($$v) {_vm.$set(_vm.searchRequest, "rentTime", $$v)},expression:"searchRequest.rentTime"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 search--boxPhase-3"},[_c('div',{staticClass:"wrap__input-box",attrs:{"id":"rentTime-wrapper"}},[_c('div',{staticClass:"col-sm-12"},[_c('i',{staticClass:"ic-time plz"}),_vm._v(" "),_c('span',{staticClass:"searchBox__input"},[_vm._v("\n                      "+_vm._s(_vm.searchRequest.durationInHour)+"\n                      "+_vm._s(_vm.searchRequest.durationInHour === 1 ? "Hour" : "Hours")+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"rentTime-box hidden"},[_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('h5',[_vm._v("\n                            Duration\n                            "),_c('span',[_vm._v(_vm._s(_vm.searchRequest.durationInHour)+"\n                              "+_vm._s(_vm.searchRequest.durationInHour === 1
                                  ? "Hour"
                                  : "Hours"))])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"col-sm-12 plz list-time"},[_c('ul',{staticClass:"picktime-hour"},_vm._l((_vm.durationValue),function(item,index){return _c('li',{key:index},[_c('a',{class:{
                                      selected:
                                        item === _vm.searchRequest.durationInHour,
                                    },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.onClickDurationPicker(item)}}},[_vm._v(_vm._s(item)+"\n                                    "+_vm._s(item === 1 ? "Hour" : "Hours"))])])}),0)])])])]),_vm._v(" "),_vm._m(8)])])])])])])])],_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n        FIND TRANSPORTATION\n      ")])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rental-search-label-box"},[_c('div',{staticClass:"search-location-label"},[_c('label',[_vm._v("Pickup Location")])]),_vm._v(" "),_c('div',{staticClass:"rental-company-label"},[_c('label',[_vm._v("Duration")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"autoComplete-rentalResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 differ-box hidden"},[_c('i',{staticClass:"ic-marker-maps --grey50"}),_vm._v(" "),_c('div',{staticClass:"searchBox__input searchBox__input-to",attrs:{"tabindex":"2"}},[_vm._v("\n                      Surabaya\n                    ")]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"arrival"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crowen cBet"},[_c('div',{staticClass:"list-time-footer cBet"},[_c('a',{staticClass:"--orange75 apply-renttime",staticStyle:{"margin-left":"auto"},attrs:{"href":"javascript:void(0)"}},[_c('strong',[_vm._v("Apply")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rental-search-label-box"},[_c('div',{staticClass:"rental-date-label"},[_c('label',[_vm._v("Pickup Date & Time")])]),_vm._v(" "),_c('div',{staticClass:"rental-time-label"},[_c('label',[_vm._v("Company")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rental-search-label-box",attrs:{"id":"search-rental-label-inline"}},[_c('div',{staticClass:"search-location-label"},[_c('label',[_vm._v("Pickup Location")])]),_vm._v(" "),_c('div',{staticClass:"rental-date-label"},[_c('label',[_vm._v("Pickup Date & Time")])]),_vm._v(" "),_c('div',{staticClass:"rental-time-label"},[_c('label',[_vm._v("Duration")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"autoComplete-rentalResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 differ-box hidden"},[_c('i',{staticClass:"ic-marker-maps --grey50"}),_vm._v(" "),_c('div',{staticClass:"searchBox__input searchBox__input-to",attrs:{"tabindex":"2"}},[_vm._v("\n                      Surabaya\n                    ")]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"arrival"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crowen cBet"},[_c('div',{staticClass:"list-time-footer cBet"},[_c('a',{staticClass:"--orange75 apply-renttime",staticStyle:{"margin-left":"auto"},attrs:{"href":"javascript:void(0)"}},[_c('strong',[_vm._v("Apply")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_availability_form_Rental__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_availability_form_MultiTrip__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_availability_form_Transfer__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_google_autocomplete_js__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_master_company_companyService_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_constants__ = __webpack_require__(237);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    rentalSearchForm: __WEBPACK_IMPORTED_MODULE_3__components_availability_form_Rental__["a" /* default */],
    airportTransferSearchForm: __WEBPACK_IMPORTED_MODULE_5__components_availability_form_Transfer__["a" /* default */],
    multiTripForm: __WEBPACK_IMPORTED_MODULE_4__components_availability_form_MultiTrip__["a" /* default */]
  },
  data: function data() {
    return {
      isSearchModeVisible: false,
      bannerImage: null,
      autocomplete: null,
      mode: "airport-transfer",
      permissions: {},
      companies: [],
      UserType: __WEBPACK_IMPORTED_MODULE_8__models_constants__["p" /* UserType */],
      profile: null
    };
  },

  computed: {
    allowSearchInquiry: function allowSearchInquiry() {
      var _this = this;

      if (this.permissions["InquiryAvailability"]) {
        return ["SearchAirport", "SearchRental"].some(function (service) {
          return _this.permissions["InquiryAvailability"].includes(service);
        });
      } else {
        return false;
      }
    },
    allowSearchInstant: function allowSearchInstant() {
      var _this2 = this;

      if (this.permissions["InstantAvailability"]) {
        return ["SearchAirport", "SearchRental"].some(function (service) {
          return _this2.permissions["InstantAvailability"].includes(service);
        });
      } else {
        return false;
      }
    },
    searchModeText: function searchModeText() {
      return this.isInquiry ? "Inquiry Search" : "Instant Search";
    },
    searchModeDescription: function searchModeDescription() {
      return this.isInquiry ? "Unchecked for instant search" : "Checked for inquiry search";
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.$store.dispatch("setting/removeSetting");

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this3.initUserPermissions(), _this3.initGLobalSettings()]);

            case 4:
              _context.next = 6;
              return _this3.getAllCompanies();

            case 6:

              _this3.$helper.scrollTop();

              // document.querySelectorAll(".product-header").forEach((element) => element.classList.remove("active"));
              // document.querySelector(".product-header").classList.add("active");
              _this3.$helper.collapseMenu();
              _this3.$helper.setNavigationClass();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },
  mounted: function mounted() {
    // creates map instance
    this.autocomplete = new __WEBPACK_IMPORTED_MODULE_6__plugins_google_autocomplete_js__["a" /* default */]();
  },

  methods: {
    getAllCompanies: function getAllCompanies() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.companies.length === 0)) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_company_companyService_js__["a" /* default */].getAllActive();

              case 3:
                _this4.companies = _context2.sent;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    initUserPermissions: function initUserPermissions() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var profile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.$store.dispatch("user/getProfile");

              case 2:
                profile = _context3.sent;

                _this5.profile = profile;
                _this5.permissions = profile.services;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    initGLobalSettings: function initGLobalSettings() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var publicSettings;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this6.$store.dispatch("setting/getAllPublic");

              case 2:
                publicSettings = _context4.sent;


                // this.mode = this.$helper.extractSetting(
                //   publicSettings,
                //   "SearchMode",
                //   "Inquiry"
                // );
                // this.mode = 'Hybrid';
                _this6.isSearchModeVisible = _this6.$helper.extractSetting(publicSettings, "SearchCollection", false);
                _this6.bannerImage = _this6.$helper.extractSetting(publicSettings, "HomeBanner", null);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    }
  }
});

/***/ }),

/***/ 814:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_master_airportService_js__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: { type: String, required: true }
  },
  data: function data() {
    return {
      isSubmitted: false,
      airports: [],
      popularDestinations: [],
      isModified: false,
      isDepartureFromAirport: false,
      isAvoidCrossCity: false,
      minimumPickUpDate: null,
      refreshSessionInterval: null,
      searchClone: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        dropOffLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        }
      },
      searchRequest: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        dropOffLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        pickUpDate: null,
        pickUpTime: null,
        mode: ""
      },
      searchRequestHourly: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        rentDate: null,
        rentTime: null,
        durationInHour: null,
        isSelfDrive: false,
        mode: ""
      },
      trip: ["airport"]
    };
  },
  validations: function validations() {
    return {
      searchRequest: {
        pickUpLocation: {
          name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
        },
        dropOffLocation: {
          name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
        },
        pickUpDate: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        pickUpTime: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
      }
    };
  },

  computed: {
    departureAirports: function departureAirports() {
      if (this.searchRequest && this.searchRequest.pickUpLocation && this.searchRequest.pickUpLocation.name) {
        var pattern = new RegExp(this.searchRequest.pickUpLocation.name.toLowerCase(), "i");
        return this.airports.filter(function (airport) {
          return pattern.test(airport.air_code) || pattern.test(airport.air_name) || pattern.test(airport.ct_code) || pattern.test(airport.ct_name) || pattern.test(airport.cn_code) || pattern.test(airport.cn_name);
        });
      }
      return this.airports;
    },
    arrivalAirports: function arrivalAirports() {
      if (this.searchRequest && this.searchRequest.dropOffLocation && this.searchRequest.dropOffLocation.name) {
        var pattern = new RegExp(this.searchRequest.dropOffLocation.name.toLowerCase(), "i");
        return this.airports.filter(function (airport) {
          return pattern.test(airport.air_code) || pattern.test(airport.air_name) || pattern.test(airport.ct_code) || pattern.test(airport.ct_name) || pattern.test(airport.cn_code) || pattern.test(airport.cn_name);
        });
      }
      return this.airports;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var div = document.getElementById("airportTransfer");
    if (div) {
      div.querySelectorAll(".switch-But")[0].addEventListener("click", function (_) {
        _this.isDepartureFromAirport = !_this.isDepartureFromAirport;

        // swap icon
        div.querySelector(".ic-switch").classList.toggle("onReverse");

        // swap location
        var tempLocation = _this.searchRequest.pickUpLocation;
        _this.searchRequest.pickUpLocation = _this.searchRequest.dropOffLocation;
        _this.searchRequest.dropOffLocation = tempLocation;

        // swap clone location
        var tempCloneLocation = _this.searchClone.pickUpLocation;
        _this.searchClone.pickUpLocation = _this.searchClone.dropOffLocation;
        _this.searchClone.dropOffLocation = tempCloneLocation;
      });
    }

    document.addEventListener("click", function (event) {
      var div = document.querySelector("#airportTransfer");
      if (div) {
        div.querySelectorAll(".list-autoComplete, .popularCity, .geolocationAirport").forEach(function (element) {
          return element.classList.remove("isOpen");
        });
      }
      if ($("#airportTransfer .searchBox__input-from, #airportTransfer .searchBox__input-to").is(event.target)) {
        var searchResult = $(event.target.parentElement).find(".list-autoComplete");
        var popularCity = $(event.target.parentElement).find(".popularCity");
        var geolocationAirport = $(event.target.parentElement).find(".geolocationAirport");

        if (searchResult.length > 0 && searchResult[0].getElementsByTagName("li").length > 0) {
          searchResult[0].classList.add("isOpen");
        } else if (popularCity.length > 0 && popularCity[0].getElementsByTagName("li").length > 0) {
          popularCity[0].classList.add("isOpen");
        } else if (geolocationAirport.length > 0 && geolocationAirport[0].getElementsByTagName("li").length > 0) {
          geolocationAirport[0].classList.add("isOpen");
        }
      }
    });

    $(".help-tip").popover({ trigger: "hover" });
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, minDays, self, pickUpLocations, dropOffLocations, minHourly, tempDurationList, i, defaultHour, defaultMinute, hourlyPickUpLocations;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$store.dispatch("setting/getAllPublic");

            case 2:
              publicSettings = _context.sent;
              minDays = parseInt(_this2.$helper.extractSetting(publicSettings, "SearchMinDay", 0));

              _this2.isAvoidCrossCity = _this2.$helper.extractSetting(publicSettings, "AvoidCrossCity", "false") === "true";

              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__services_master_airportService_js__["a" /* default */].getAll();

            case 7:
              _this2.airports = _context.sent;
              self = _this2;
              // subscribe messages

              _this2.$eventBus.$on("navigateToAirportTransfer", function () {
                return self.$parent.autocomplete.refreshToken();
              });
              _this2.$eventBus.$on("bindAirportTransfer", _this2.bindModelFromModifySearch);

              _this2.refreshSessionInterval = setInterval(function () {
                self.$parent.autocomplete.refreshToken();
              }, 60000);

              pickUpLocations = _this2.$helper.extractSetting(publicSettings, "AirportPickup", "-6.1275282|106.6537058|Soekarno-Hatta International Airport|Soekarno-Hatta International Airport, Tangerang City, Banten, Indonesia|ID|CGK").split("|");


              _this2.searchRequest.pickUpLocation = {
                latitude: parseFloat(pickUpLocations[0]),
                longitude: parseFloat(pickUpLocations[1]),
                name: pickUpLocations[2],
                address: pickUpLocations[3],
                country: pickUpLocations[4]
              };

              _this2.searchClone.pickUpLocation = {
                latitude: parseFloat(pickUpLocations[0]),
                longitude: parseFloat(pickUpLocations[1]),
                name: pickUpLocations[2],
                address: pickUpLocations[3],
                country: pickUpLocations[4]
              };

              if (pickUpLocations.length === 6) {
                _this2.isDepartureFromAirport = true;
                _this2.searchRequest.pickUpLocation.code = pickUpLocations[5];
                _this2.searchRequest.pickUpLocation.isAirportZone = true;

                _this2.searchClone.pickUpLocation.code = pickUpLocations[5];
                _this2.searchClone.pickUpLocation.isAirportZone = true;
              }

              dropOffLocations = _this2.$helper.extractSetting(publicSettings, "AirportDropoff", "-6.1767112|106.8306527|Gambir Station|Gambir Station, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia|ID").split("|");


              _this2.searchRequest.dropOffLocation = {
                latitude: parseFloat(dropOffLocations[0]),
                longitude: parseFloat(dropOffLocations[1]),
                name: dropOffLocations[2],
                address: dropOffLocations[3],
                country: dropOffLocations[4]
              };

              _this2.searchClone.dropOffLocation = {
                latitude: parseFloat(dropOffLocations[0]),
                longitude: parseFloat(dropOffLocations[1]),
                name: dropOffLocations[2],
                address: dropOffLocations[3],
                country: dropOffLocations[4]
              };

              if (dropOffLocations.length === 6) {
                _this2.isDepartureFromAirport = false;
                _this2.searchRequest.dropOffLocation.code = dropOffLocations[5];
                _this2.searchRequest.dropOffLocation.isAirportZone = true;

                _this2.searchClone.dropOffLocation.code = dropOffLocations[5];
                _this2.searchClone.dropOffLocation.isAirportZone = true;
              }

              _this2.searchRequest.pickUpDate = _this2.$helper.toStringDate(_this2.$helper.addDays(minDays));

              _this2.searchRequest.pickUpTime = "10:00";

              _this2.minimumPickUpDate = _this2.$helper.toStringDate(_this2.$helper.addDays(minDays));

              _this2.popularDestinations = [
                // {
                //   name: "Soekarno-Hatta International Airport",
                //   address: "Soekarno-Hatta International Airport, Tangerang City, Banten, Indonesia",
                //   country: "ID",
                //   isAirportZone: true,
                //   lat: -6.127119,
                //   lng: 106.6534595,
                // },
                // {
                //   name: "Gambir Station",
                //   address: "Gambir Station, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia",
                //   country: "ID",
                //   isAirportZone: false,
                //   lat: -6.1767112,
                //   lng: 106.8306527,
                // },
                // {
                //   name: "Halim Perdana Kusuma",
                //   address: "Halim Perdana Kusuma, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia",
                //   country: "ID",
                //   isAirportZone: true,
                //   lat: -6.265208800000002,
                //   lng: 106.8863459,
                // },
              ];

              // Hourly form setting

              minHourly = publicSettings.find(function (val) {
                return val.key === "MinimumHourlyHire";
              });
              tempDurationList = [];

              for (i = minHourly.value; i <= 24; i++) {
                tempDurationList.push(Number(i));
              }
              _this2.durationValue = tempDurationList;
              // const minHourlyDays = parseInt(
              //   this.$helper.extractSetting(publicSettings, "SearchMinDay", 0)
              // );

              // const country = this.$helper.extractSetting(
              //   publicSettings,
              //   "CountryHours",
              //   0
              // );
              // subscribe messages
              _this2.$eventBus.$on("navigateToVehicleRental", function () {
                self.$parent.autocomplete.refreshToken();
              });
              _this2.$eventBus.$on("bindVehicleRental", _this2.bindModelFromModifySearch);

              _this2.refreshSessionInterval = setInterval(function () {
                self.$parent.autocomplete.refreshToken();
              }, 60000);

              defaultHour = 10;
              defaultMinute = 0;


              _this2.minimumRentDate = _this2.$helper.toStringDate(_this2.$helper.addDays(minDays));

              hourlyPickUpLocations = _this2.$helper.extractSetting(publicSettings, "RentalPickup", "-6.2023616|106.8119382|National Monument|National Monument, Gambir, Central Jakarta City, Jakarta, Indonesia|ID").split("|");


              _this2.searchRequestHourly = {
                pickUpLocation: {
                  latitude: parseFloat(hourlyPickUpLocations[0]),
                  longitude: parseFloat(hourlyPickUpLocations[1]),
                  name: hourlyPickUpLocations[2],
                  address: hourlyPickUpLocations[3],
                  country: hourlyPickUpLocations[4],
                  isAirportZone: false
                },
                rentDate: _this2.$helper.toStringDate(_this2.$helper.addDays(minDays)),
                rentTime: defaultHour + ":0" + defaultMinute,
                durationInHour: Number(minHourly.value) || 1,
                isSelfDrive: false
              };

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    // unsubscribe message
    this.$eventBus.$off("navigateToAirportTransfer");
    clearInterval(this.refreshSessionInterval);
  },

  methods: {
    pushTrip: function pushTrip(serviceType) {
      var value = serviceType === "hourly" ? "hourly" : "airport";
      this.trip.push(value);
    },
    bindModelFromModifySearch: function bindModelFromModifySearch(searchParameter) {
      this.isModified = true;

      this.searchRequest = {
        pickUpLocation: {
          latitude: searchParameter.pickUpLocation.latitude,
          longitude: searchParameter.pickUpLocation.longitude,
          code: searchParameter.pickUpLocation.code,
          name: searchParameter.pickUpLocation.name,
          address: searchParameter.pickUpLocation.address,
          country: searchParameter.pickUpLocation.country,
          isAirportZone: searchParameter.pickUpLocation.isAirportZone
        },
        dropOffLocation: {
          latitude: searchParameter.dropOffLocation.latitude,
          longitude: searchParameter.dropOffLocation.longitude,
          code: searchParameter.dropOffLocation.code,
          name: searchParameter.dropOffLocation.name,
          address: searchParameter.dropOffLocation.address,
          country: searchParameter.dropOffLocation.country,
          isAirportZone: searchParameter.dropOffLocation.isAirportZone
        },
        pickUpDate: this.$helper.toDateString(searchParameter.pickUpDateTime, "YYYY-MM-DD"),
        pickUpTime: this.$helper.toDateString(searchParameter.pickUpDateTime, "HH:mm"),
        mode: searchParameter.mode
      };

      this.searchClone = {
        pickUpLocation: {
          latitude: searchParameter.pickUpLocation.latitude,
          longitude: searchParameter.pickUpLocation.longitude,
          code: searchParameter.pickUpLocation.code,
          name: searchParameter.pickUpLocation.name,
          address: searchParameter.pickUpLocation.address,
          country: searchParameter.pickUpLocation.country,
          isAirportZone: searchParameter.pickUpLocation.isAirportZone
        },
        dropOffLocation: {
          latitude: searchParameter.dropOffLocation.latitude,
          longitude: searchParameter.dropOffLocation.longitude,
          code: searchParameter.dropOffLocation.code,
          name: searchParameter.dropOffLocation.name,
          address: searchParameter.dropOffLocation.address,
          country: searchParameter.dropOffLocation.country,
          isAirportZone: searchParameter.dropOffLocation.isAirportZone
        }
      };

      // indicates whether departure using geolocation or google maps autocomplete
      this.isDepartureFromAirport = this.searchRequest.pickUpLocation.code !== undefined;
    },
    onKeyupAirportGeolocation: function onKeyupAirportGeolocation(target) {
      target.parentElement.querySelector(".geolocationAirport").classList.add("isOpen");
    },
    onClickAirportGeolocation: function onClickAirportGeolocation(airport, target) {
      switch (target) {
        case "pickup":
          this.searchRequest.pickUpLocation = {
            latitude: airport.lat,
            longitude: airport.long,
            code: airport.air_code,
            name: airport.air_name,
            address: airport.air_name,
            country: airport.cn_code
          };
          break;
        case "dropoff":
          this.searchRequest.dropOffLocation = {
            latitude: airport.lat,
            longitude: airport.long,
            code: airport.air_code,
            name: airport.air_name,
            address: airport.air_name,
            country: airport.cn_code
          };
          break;
      }
    },
    onClickPopularDestination: function onClickPopularDestination(popular, target) {
      switch (target) {
        case "pickup":
          this.searchRequest.pickUpLocation = {
            latitude: popular.lat,
            longitude: popular.lng,
            name: popular.name,
            address: popular.address,
            country: popular.country,
            isAirportZone: popular.isAirportZone
          };
          break;
        case "dropoff":
          this.searchRequest.dropOffLocation = {
            latitude: popular.lat,
            longitude: popular.lng,
            name: popular.name,
            address: popular.address,
            country: popular.country,
            isAirportZone: popular.isAirportZone
          };
          break;
      }
    },
    onFocusAutoComplete: function onFocusAutoComplete(target) {
      target.value = "";
    },
    onBlurAutoComplete: function onBlurAutoComplete(target) {
      switch (target.name) {
        case "airportPickUpLocation":
          target.value = this.searchRequest.pickUpLocation.name;
          var isEqualPickUpLocation = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(this.searchRequest.pickUpLocation, this.searchClone.pickUpLocation);
          if (!isEqualPickUpLocation) {
            this.searchRequest.pickUpLocation.name = "";
          }
          break;
        case "airportDropOffLocation":
          target.value = this.searchRequest.dropOffLocation.name;
          var isEqualDropOffLocation = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(this.searchRequest.dropOffLocation, this.searchClone.dropOffLocation);
          if (!isEqualDropOffLocation) {
            this.searchRequest.dropOffLocation.name = "";
          }
          break;
      }
    },
    onKeyupAutoComplete: function onKeyupAutoComplete(target) {
      var _this3 = this;

      document.querySelectorAll(".popularCity").forEach(function (element) {
        return element.classList.remove("isOpen");
      });

      var self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(function (_) {
        var autoCompleteResultElement = null;
        var options = {};
        var prefix = "";
        switch (target.name) {
          case "airportPickUpLocation":
            autoCompleteResultElement = document.getElementById("pickup-airportAutoCompleteResults");
            //options.country = self.searchRequest.dropOffLocation.country;
            if (self.isAvoidCrossCity) {
              var airport = _this3.airports.find(function (x) {
                return x.air_code === self.searchRequest.dropOffLocation.code;
              });
              if (airport) {
                prefix = airport.ct_name + ", ";
              }
            }
            break;
          case "airportDropOffLocation":
            autoCompleteResultElement = document.getElementById("dropoff-airportAutoCompleteResults");
            // options.country = self.searchRequest.pickUpLocation.country;
            if (self.isAvoidCrossCity) {
              var _airport = _this3.airports.find(function (x) {
                return x.air_code === self.searchRequest.pickUpLocation.code;
              });
              if (_airport) {
                prefix = _airport.ct_name + ", ";
              }
            }
            break;
        }
        // reset suggestion result
        autoCompleteResultElement.innerHTML = "";

        // handle empty pick-up location keyword
        if (target.value === "") {
          autoCompleteResultElement.parentElement.classList.remove("isOpen");
          return;
        }

        self.$parent.autocomplete.getPredictions("" + prefix + target.value, function (predictions) {
          // loop result
          predictions.forEach(function (prediction) {
            var item = document.createElement("li");
            item.innerHTML = self.$helper.getPlaceIcon(prediction.types) + "<div class='point-of-view'>" + prediction.structured_formatting.main_text + "</div>" + "<span>" + prediction.structured_formatting.secondary_text + "</span>";
            item.addEventListener("click", function (_) {
              return self.getPlace(target, prediction);
            });
            autoCompleteResultElement.appendChild(item);
          });
          // show the result
          autoCompleteResultElement.parentElement.classList.add("isOpen");
        }, options);
      }, 200);
    },
    getPlace: function getPlace(target, prediction) {
      var self = this;
      var result = null;
      self.$parent.autocomplete.getPlace(prediction, function (place) {
        var isAirportZone = prediction.types.includes("airport") ? true : false;

        switch (target.name) {
          case "airportPickUpLocation":
            result = document.getElementById("pickup-airportAutoCompleteResults");
            self.searchRequest.pickUpLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            self.searchClone.pickUpLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            self.handleDifferentCountry();
            break;
          case "airportDropOffLocation":
            result = document.getElementById("dropoff-airportAutoCompleteResults");
            self.searchRequest.dropOffLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            self.searchClone.dropOffLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            break;
        }
        // everytime user select the prediction, result list should be reset
        result.innerHTML = "";
      });
    },
    buildQueryParam: function buildQueryParam(request) {
      var queryParam = {};

      // pick-up
      queryParam.plt = request.pickUpLocation.latitude;
      queryParam.plg = request.pickUpLocation.longitude;
      queryParam.pcd = request.pickUpLocation.code;
      queryParam.pad = request.pickUpLocation.address;
      queryParam.pnm = request.pickUpLocation.name;
      queryParam.pcn = request.pickUpLocation.country;
      queryParam.pia = request.pickUpLocation.isAirportZone;

      // drop-off
      queryParam.dlt = request.dropOffLocation.latitude;
      queryParam.dlg = request.dropOffLocation.longitude;
      queryParam.dcd = request.dropOffLocation.code;
      queryParam.dad = request.dropOffLocation.address;
      queryParam.dnm = request.dropOffLocation.name;
      queryParam.dcn = request.dropOffLocation.country;
      queryParam.dia = request.dropOffLocation.isAirportZone;

      // start rent
      queryParam.ptm = request.pickUpDateTime.year + "." + request.pickUpDateTime.month + "." + request.pickUpDateTime.day + "-" + request.pickUpDateTime.hour + "." + request.pickUpDateTime.minute;

      // service type
      queryParam.svc = "airporttransfer";

      // HACK: handle duplication routing
      queryParam.ver = Math.random().toString(36).substr(2, 9);

      // search mode
      queryParam.mode = request.mode;

      return queryParam;
    },
    search: function search() {
      this.isSubmitted = true;
      this.$v.searchRequest.$touch();
      if (this.$v.searchRequest.$error) {
        return;
      }
      // parse datetime
      if (this.searchRequest.pickUpDate && this.searchRequest.pickUpTime) {
        var pickUpDates = this.searchRequest.pickUpDate.split("-");
        var pickUpTimes = this.searchRequest.pickUpTime.split(":");
        this.searchRequest.pickUpDateTime = {
          year: parseInt(pickUpDates[0]),
          month: parseInt(pickUpDates[1]),
          day: parseInt(pickUpDates[2]),
          hour: parseInt(pickUpTimes[0]),
          minute: parseInt(pickUpTimes[1])
        };

        // this.searchRequest.mode = this.mode;
        this.searchRequest.mode = "Inquiry";

        if (this.searchRequest.mode === "Inquiry") {
          if (this.isModified) {
            this.$eventBus.$emit("executeModifySearch", this.buildQueryParam(this.searchRequest));
          } else {
            this.$router.push({
              path: "/availability/inquiry",
              query: this.buildQueryParam(this.searchRequest)
            });
          }
        } else {
          if (this.isModified) {
            this.$eventBus.$emit("executeModifySearch", this.buildQueryParam(this.searchRequest));
          } else {
            this.$router.push({
              path: "/availability/instant",
              query: this.buildQueryParam(this.searchRequest)
            });
          }
        }
      }
    },
    handleDifferentCountry: function handleDifferentCountry() {
      if (this.searchRequest.pickUpLocation.country != this.searchRequest.dropOffLocation.country) {
        this.searchRequest.dropOffLocation = {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0
        };

        var dropOffTextbox = document.getElementsByName("airportDropOffLocation")[0];

        if (dropOffTextbox) {
          dropOffTextbox.click();
          dropOffTextbox.focus();
        }
      }
    },
    validateButton: function validateButton() {
      return this.searchRequest.pickUpLocation.name && this.searchRequest.dropOffLocation.name;
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/28.278b905944cfbe999718.js